import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/bTDevices/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/bTDevices/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/bTDevices/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/bTDevices/delete',
    method: 'post',
    data
  })
}

